// Support docs opened from the Team Budget section header help ("?") icon.
export const TEAM_BUDGET_SUPPORT_URL =
  'https://support.sportninja.com/team-budget'
